import Dinero from 'dinero.js';

export function CurrencyFilter(amount: number | null | string, options: {
	precision: number
} = {
	precision: 2
}) {
	if(amount === undefined || amount === null || amount === '' || typeof amount === 'string') {
		return '$-.--';
	}
	// Precision doesn't change the format so this is a poor-man's precision
	// since we only have 2 real formats right now I think this is fine.
	let format = '$0,0.00';
	if(options.precision === 0) {
		format = '$0,0';
	}
	return Dinero({
		amount: amount,
		currency: 'USD',
	}).toFormat(format);
}
